/// <reference path="../../Common/Base/SiteEntityDialog.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class AccountRoleDialog extends SiteEntityDialog<AccountRoleRow, any> {
        protected getFormKey() { return AccountRoleForm.formKey; }
        protected getIdProperty() { return AccountRoleRow.idProperty; }
        protected getLocalTextPrefix() { return AccountRoleRow.localTextPrefix; }
        protected getNameProperty() { return AccountRoleRow.nameProperty; }
        protected getService() { return AccountRoleService.baseUrl; }

        protected form = new AccountRoleForm(this.idPrefix);

    }
}